module.exports = __webpack_public_path__ + "img/spinner-big.ea49e48a.svg";